import VueQRCodeComponent from 'vue-qrcode-component'

import customer from '../common/customer'
import device from '../common/device'
import AlertValidationErrorsFromAjax from '../components/AlertValidationErrorsFromAJAX'
import common, { Vue } from '../imports/global'
import TheAddPackModal from './components/TheAddPackModal.vue'
import computed from './computed.js'
/* DATA */
import data from './inData.js'
import methodsDevices from './methodsDevices.js'
import methodsGeneral from './methodsGeneral.js'
import computedValidations from './validations.js'

/** Using vue mixin, so we can use the mixins in every child components without declaring the values **/
Vue.mixin({
  data () {
    return {
      order_steps: [
        'offer', 'cga', 'devices', 'customer', 'payment', 'summary'
      ],

      steps: {
        offer: {
          icon: 'shopping-bag',
          name: 'Choix du produit',
          visited: true
        },
        cga: {
          icon: 'file-signature',
          name: 'CGA & IPID',
          visited: false
        },
        devices: {
          icon: 'laptop-house',
          name: 'Mes appareils',
          visited: false
        },
        customer: {
          icon: 'address-card',
          name: 'Infos client',
          visited: false
        },
        payment: {
          icon: 'credit-card',
          name: 'Infos paiement',
          visited: false
        },
        summary: {
          icon: 'address-book',
          name: 'Résumé',
          visited: false
        }
      }
    }
  }
})

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  components: {
    AlertValidationErrorsFromAjax,
    TheAddPackModal,
    'qr-code': VueQRCodeComponent
  },

  mixins: [
    common,
    data,
    computed,
    computedValidations,
    methodsGeneral,
    methodsDevices,
    customer,
    device
  ],

  async created () {
    /* Put the registration in step 3 for Insurance subscription */
    if (window.guest) this.order_steps.splice(3, 0, 'accountRegistration')

    /* GET INFOS NEEDED */

    /* GET Insurance offers */
    await window.axios(window.routes.offers)
      .then(response => {
        this.offers = response.data

        if (window.offer_types.length > 0) {
          this.offers = this.offers
            .filter(offer => window.offer_types.some(type => offer.identifier.includes(type)))
        }

        if (this.firstOffer.mandatory_payment_frequency === 2) {
          this.payment_frequency = 'y'
        }
      })

    /* GET Terms and Conditions */
    window.axios(window.routes.terms_and_conditions).then(response => {
      this.terms_and_conditions = response.data.data
    })

    /* GET BRANDS */
    window.axios(window.routes.brands).then(response => {
      this.data_device.brands = response.data.data
    })
    /* GET CITIES */
    window.axios(window.routes.get_cities).then(response => {
      this.cities = response.data.data
    })
  },

  methods: {
    /* STEP 1 */

    /* Modal change offer */
    open_model_change_offer (offerIdentifier) {
      /* If there is no chosen offer or the chosen offer is a new one */
      if (!this.chosenOffer || offerIdentifier !== this.chosenOffer.identifier) {
        /* Open model if there is at least one information filled */
        if (this.is_devices_filled) {
          this.visibleModal = this.modalNames.changeOffer
          this.tempChosenOfferIdentifier = offerIdentifier
          /* Else if empty, can change offer without opening modal */
        } else this.selectOffer(offerIdentifier)
      }
    },

    selectOffer (offerIdentifier) {
      /* Reset previous data */
      this.cga_checked = false

      this.chosen_offer_html = this.$refs[offerIdentifier][0].$el.outerHTML

      /* Save the index to don't show the offer on the list */
      this.chosenOfferIdentifier = offerIdentifier
      this.steps.cga.available = true

      /* Device age */
      /* Set the Date min general for all categories */
      this.date.min = window.moment()
        .startOf('day')
        .subtract(this.chosenOffer.max_device_age === 9999 ? 1800 : this.chosenOffer.max_device_age, 'months')
        .format('YYYY-MM-DD')
      /*
       * If max_device_age_per_category exist
       * Create min_date and max_age for each category
       * */
      if (this.chosenOffer.max_device_age_per_category) {
        this.chosenOffer.max_device_age_per_category.forEach(maxDeviceAgeForCategory => {
          this.$set(this.date, maxDeviceAgeForCategory.category.name, {
            min_date: window.moment()
              .startOf('day')
              .subtract(maxDeviceAgeForCategory.max_age, 'months')
              .format('YYYY-MM-DD'),
            max_age: maxDeviceAgeForCategory.max_age
          })
        })
      }

      /* update brands if allowed brand is defined */
      if (this.chosenOffer.allowed_brands) this.data_device.brands = this.chosenOffer.allowed_brands

      /* Set payment frequency to monthly because a professional can't pay annually */
      if (this.chosenOffer.audience_type === 'PRO') {
        this.customer_infos.gender = 3
        this.payment_frequency = 'm'
      } else if (this.customer_infos.gender === 3) this.customer_infos.gender = null

      /* Remove all the old devices */
      this.devices = []
      this.cga_checked = false

      this.next()
    },

    /** STEP 2 */
    checkCga () {
      this.cga_checked = !this.cga_checked
      if (this.cga_checked) this.next()

      /* Create a device ( if the max is same as min => create all the devices ) */
      this.newDevice()
    },

    /** STEP 3 */

    delete_device_keyup (e) {
      if (e.key === 'Enter') this.deleteDevice(this.current_delete_device_index)
    },

    /* verify that there is no information selected */
    cancelOrder () {
      this.is_devices_filled
        ? this.open_model_cancel_order()
        : window.location.href = this.routes.home
    },

    /** STEP 6 */
    /** RESUME */
    /* SEND ORDER TO Create it */
    confirmOrder () {
      this.isConfirmOrderLoading = true

      window.axios.post(this.routes.create_contract, {
        /* Order information */
        customer_infos: this.customer_infos,
        devices: this.devicesWithSNorImei,
        offer: this.chosenOffer,
        iban: this.iban,
        payment_frequency: this.payment_frequency,
        mandate_signature: this.mandate_signature

      }, {
        headers: {
          'content-type': 'application/json'
        }
      }).then(response => {
        if (response.data.order_id !== undefined) {
          window.location.href = this.routes.subscription_detail + '/' + response.data.order_id
        }
      }).catch(error => {
        this.isConfirmOrderLoading = false
        console.log(error)
        // "Il y a une erreur exceptionnelle lors de la validation d'un ou plusieurs champs des formulaires"
      })
    }
  }
})
